import { IDevice } from "./IDevice"

export class AO extends IDevice
{
    constructor(name, props, deviceType)
    {
        super(name, props, deviceType);
    }
}
